import { useEffect, useMemo } from "react";
import SearchIcon from "@/common/images/icons/search.svg?react";
import ResetIcon from "@/common/images/icons/x.svg?react";
import BackIcon from "@/common/images/icons/chevron.svg?react";
import { clsx } from "clsx";
import { decodeTag } from "@/common/utils/strings";
import { useQuery } from "@/common/hooks/useQuery";
import { useSearchInputHandlers } from "./hooks/useSearchInputHandlers";
import { useDeviceType } from "@/common/hooks";
import "./SearchInput.scss";
import { deviceTypeEnum } from "@/common/utils/device";

interface ISearchInput {
  searchValue: string;
  inputRef: React.RefObject<HTMLInputElement | null>;
  onSetSearchValue: (value: string) => void;
}

export const SearchInput = ({ searchValue, inputRef, onSetSearchValue }: ISearchInput) => {
  const query = useQuery();
  const deviceType = useDeviceType();
  const isDesktop = useMemo(() => deviceType === deviceTypeEnum.DESKTOP, [deviceType]);

  const {
    isFocused,
    handleFocus,
    handleBlur,
    handleChange,
    handleSelect,
    handleClear,
    handleKeyDown,
    handleCloseSearch,
  } = useSearchInputHandlers({ searchValue, onSetSearchValue });

  useEffect(() => {
    const tagParam = location.pathname.match(/^\/gifs\/([^/]+)/);

    if (tagParam !== null) {
      onSetSearchValue(decodeTag(tagParam[1]));
    } else {
      onSetSearchValue(query.get("query") ?? "");
    }
  }, [location.pathname, query]);

  return (
    <div className="searchInput">
      <button className="closeSearchButton" onClick={handleCloseSearch}><BackIcon className="backIcon" /></button>
      <div className={clsx(
        "searchInputWrapper",
        isFocused && "searchInputFocused",
        searchValue && "searchInputFilled"
      )}>
        <span className="searchIcon"><SearchIcon /></span>
        <input
          className="searchInputField"
          ref={inputRef}
          id="global-search-input"
          type="text"
          autoComplete="off"
          placeholder={`Search ${isDesktop ? "" : "RedGIFs..."}`}
          value={searchValue}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
          onSelect={handleSelect}
          onKeyDown={handleKeyDown}
        />
        {!isFocused && isDesktop && (
          <div className="dynamicText">
            <div className="word">GIFs</div>
            <div className="word">Creators</div>
            <div className="word">Niches</div>
            <div className="word">Tags</div>
            <div className="word">GIFs</div>
          </div>
        )}
        <button className="resetSearchButton" onClick={handleClear}><ResetIcon className="resetIcon" /></button>
      </div>
    </div>
  );
};
